import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.initializeTooltip();
  }

  initializeTooltip() {
    const contentTemplate = this.contentTarget;
    const contentNode = contentTemplate.content.cloneNode(true);
    const contentHtml = document.createElement("div");
    contentHtml.appendChild(contentNode);

    const elements = this.element.querySelectorAll(".element-tooltip");

    elements.forEach((element) => {
      const isInteractive = element.classList.contains("interactive");

      tippy(element, {
        content: contentHtml.innerHTML,
        allowHTML: true,
        placement: "right",
        arrow: false,
        maxWidth: 400,
        interactive: isInteractive,
        appendTo: document.body,
        delay: [0, 0],
        duration: [100, 100],
      });
    });
  }
}
